import React, { useState } from "react";
import "./MeusLivros.css";
import useLivrosAdquiridos from "../../../hooks/useLivrosAdquiridos";

function MeusLivros() {
  const { books, loading, error } = useLivrosAdquiridos();
  const [downloadMessage, setDownloadMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const apiUrl = process.env.REACT_APP_API;

  const handleDownload = async (book) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(apiUrl + `api/usuario-editora/get-pdf?book_id=${book.id}&pdf_path=${book.pdf}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${book.titulo}.pdf`;
      link.click();

      window.URL.revokeObjectURL(url);

      // Exibir mensagem de sucesso
      setDownloadMessage("Seu download começará em instantes. Verifique sua pasta de downloads.");
      setShowPopup(true);

      // Ocultar o pop-up após 3 segundos
      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
    } catch (error) {
      console.error("Error downloading PDF:", error.message);
      setDownloadMessage("Ocorreu um erro ao tentar baixar o livro. Por favor, tente novamente.");
      setShowPopup(true);

      setTimeout(() => {
        setShowPopup(false);
      }, 3000);
    }
  };

  return (
    <div className="meusLivros-container">
      <h2>Meus Livros</h2>
      {showPopup && <div className="download-popup">{downloadMessage}</div>}
      {(books.length === 0 && !loading) ? (
        <p>Nenhum livro adquirido.</p>
      ) : (
        <ul>
          {books.map((book) => (
            <div className="book-flex" key={book.id}>
              <div className="carrinho-book-img">
                <img
                  src={`https://insigneacademica.com.br/api/public/${book.image}`}
                  alt="productImage"
                ></img>
              </div>
              <div className="book">
                <h3>{book.titulo}</h3>
                <div className="book-flex">
                  <div className="book-price">Valor: R$ {book.preco}</div>
                </div>
                <button
                  className="download-button"
                  onClick={() => handleDownload(book)}
                >
                  Baixar
                </button>
              </div>
            </div>
          ))}
        </ul>
      )}
    </div>
  );
}

export default MeusLivros;
